/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteOptionCommand } from '../../models/delete-option-command';
import { DeleteOptionCommandResult } from '../../models/delete-option-command-result';

export interface ApiKpIsDeleteOptionDelete$Plain$Params {
      body?: DeleteOptionCommand
}

export function apiKpIsDeleteOptionDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiKpIsDeleteOptionDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOptionCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpIsDeleteOptionDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteOptionCommandResult>;
    })
  );
}

apiKpIsDeleteOptionDelete$Plain.PATH = '/api/KPIs/DeleteOption';
